/****************
 * THE QUERY KEYS, WRITTEN ONCE. GB-3.
 *
 * Each dashboard selector is its own cache entry, which is why the first click
 * on a period is slow and every later one is instant. The fix is to prefetch
 * the periods nobody has clicked yet -- and a prefetch is only a fix if its
 * key is EXACTLY the key the hook will look under.
 *
 * One element out of place and the prefetch warms an entry nothing reads. The
 * page stays exactly as slow as before, the network tab shows the request
 * going out, and nothing anywhere says the two disagree. That silence is why
 * these are functions with a test on them rather than two array literals
 * sitting forty lines apart.
 *
 * The socket handler identifies a cache entry's venue by the LAST element of
 * the key, so scope stays last in both.
 ****************/

// offset before scope: the scope stays the last element, where the socket looks.
export function topTradesKey(limit: number, period: string, scope: string, offset: number = 0): unknown[] {
  return ['dashboard', 'top-trades', limit, period, offset, scope];
}

export function topTradersKey(
  limit: number,
  period: string,
  isAdmin: boolean,
  includeBelowFloor: boolean,
  scope: string,
): unknown[] {
  return ['dashboard', 'top-traders', limit, period, isAdmin, includeBelowFloor, scope];
}
